"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBCheckbox = _interopRequireDefault(require("../HBCheckbox/HBCheckbox"));
var HBNewTableRowCheckbox = function HBNewTableRowCheckbox(_ref) {
  var item = _ref.item,
    itemId = _ref.itemId,
    isItemSelected = _ref.isItemSelected,
    onSelectItem = _ref.onSelectItem,
    testIdName = _ref.testIdName;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
    _react["default"].createElement(NewTableStyledCheckboxWrapper, {
      key: "select-wrapper-".concat(itemId),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /*#__PURE__*/_react["default"].createElement(_HBCheckbox["default"], {
      testIdName: testIdName !== null && testIdName !== void 0 ? testIdName : 'table-row-select',
      checked: isItemSelected,
      onChange: function onChange(e) {
        return onSelectItem(item, e.target.checked);
      },
      size: "xs"
    }))
  );
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HBNewTableRowCheckbox); // -------------------------------- Styles -------------------------------- //
var NewTableStyledCheckboxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableRowCheckbox__NewTableStyledCheckboxWrapper",
  componentId: "sc-1wjp5q3-0"
})(["line-height:0;"]);
//# sourceMappingURL=HBNewTableRowCheckbox.js.map